module.exports = __webpack_public_path__ + "static/img/15.0705f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/15.jpg
// module id = Hi7N
// module chunks = 15